import * as Yup from 'yup';

/**
 * Validation schema for path definitions
 * This schema validates the structure and required fields for path definitions
 */
export const pathDefinitionValidationSchema = Yup.object({
  name: Yup.string().required('Path definition name is required'),
  description: Yup.string().required('Description is required'),
  active: Yup.boolean().default(true),
  pattern: Yup.object({
    requiredSegmentsString: Yup.string().required('Required segments are required'),
    folderTemplate: Yup.string().required('Folder template is required'),
    requestType: Yup.string().required('Request type is required')
  }).required('Pattern is required'),
  params: Yup.array()
    .of(
      Yup.object({
        name: Yup.string().required('Parameter name is required'),
        position: Yup.number().required('Position is required'),
        required: Yup.boolean().default(true),
        isCritical: Yup.boolean().default(false),
        defaultValue: Yup.string(),
        description: Yup.string().required('Description is required')
      })
    )
    .min(1, 'At least one parameter is required')
    .required('Parameters are required')
});

// Add a debug version of the validation schema that logs validation attempts
export const debugPathDefinitionValidationSchema = Yup.object({
  name: Yup.string()
    .required('Path definition name is required')
    .test('debug-name', 'Debugging name', function (value) {
      console.log('Validating name:', value);
      return true;
    }),
  description: Yup.string()
    .required('Description is required')
    .test('debug-desc', 'Debugging description', function (value) {
      console.log('Validating description:', value);
      return true;
    }),
  active: Yup.boolean()
    .default(true)
    .test('debug-active', 'Debugging active', function (value) {
      console.log('Validating active:', value);
      return true;
    }),
  pattern: Yup.object({
    requiredSegmentsString: Yup.string()
      .required('Required segments are required')
      .test('debug-segments', 'Debugging segments', function (value) {
        console.log('Validating requiredSegmentsString:', value);
        return true;
      }),
    folderTemplate: Yup.string()
      .required('Folder template is required')
      .test('debug-template', 'Debugging template', function (value) {
        console.log('Validating folderTemplate:', value);
        return true;
      }),
    requestType: Yup.string()
      .required('Request type is required')
      .test('debug-type', 'Debugging type', function (value) {
        console.log('Validating requestType:', value);
        return true;
      })
  })
    .required('Pattern is required')
    .test('debug-pattern', 'Debugging pattern', function (value) {
      console.log('Validating pattern:', value);
      return true;
    }),
  params: Yup.array()
    .of(
      Yup.object({
        name: Yup.string()
          .required('Parameter name is required')
          .test('debug-param-name', 'Debugging param name', function (value) {
            console.log('Validating param name:', value);
            return true;
          }),
        position: Yup.number()
          .required('Position is required')
          .test('debug-param-pos', 'Debugging param position', function (value) {
            console.log('Validating param position:', value);
            return true;
          }),
        required: Yup.boolean()
          .default(true)
          .test('debug-param-req', 'Debugging param required', function (value) {
            console.log('Validating param required:', value);
            return true;
          }),
        isCritical: Yup.boolean()
          .default(false)
          .test('debug-param-critical', 'Debugging param critical', function (value) {
            console.log('Validating param isCritical:', value);
            return true;
          }),
        defaultValue: Yup.string()
          .test('debug-param-default', 'Debugging param default value', function (value) {
            console.log('Validating param defaultValue:', value);
            return true;
          }),
        description: Yup.string()
          .required('Description is required')
          .test('debug-param-desc', 'Debugging param description', function (value) {
            console.log('Validating param description:', value);
            return true;
          })
      })
    )
    .min(1, 'At least one parameter is required')
    .required('Parameters are required')
    .test('debug-params', 'Debugging params', function (value) {
      console.log('Validating params array:', value);
      return true;
    })
});

/**
 * Validation schema for path testing
 * This schema validates the input for testing path resolution
 */
export const pathTestingValidationSchema = Yup.object({
  userId: Yup.string().required('User ID is required'),
  path: Yup.string().required('Path is required')
});

// Create a named object for export
const pathRegistrySchemas = {
  pathDefinitionValidationSchema,
  debugPathDefinitionValidationSchema,
  pathTestingValidationSchema
};

// Export the named object as default
export default pathRegistrySchemas;
